import { createReducer, on } from '@ngrx/store';
import { setBaselineVersion, setNewVersionAvailable } from './version.actions';

export interface AppVersionState {
  baselineVersion: string | null;
  newVersionAvailable: boolean;
}

const initialState: AppVersionState = {
  baselineVersion: null,
  newVersionAvailable: false
};

export const reducer = createReducer<AppVersionState>(
  initialState,
  on(setBaselineVersion, (state, { version }) => ({ ...state, baselineVersion: version })),
  on(setNewVersionAvailable, (state, { available }) => ({ ...state, newVersionAvailable: available }))
);
